<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    src="@/assets/img/lateralCover.png"
    mobile-break-point="960"
    app
    width="260"
    v-bind="$attrs"
  >
    <template v-slot:img="props">
      <v-img
        :gradient="`to bottom, rgba(0, 0, 0, .5), rgba(0, 0, 0, .2)`"
        v-bind="props"
      />
    </template>

    <v-divider class="mb-1" />

    <v-list
      dense
      nav
    >
      <v-list-item >
        <!-- src="@/assets/img/logoWhite.png" -->
          <img
           
            :src = "images.logoWhite"
                 style="max-width:220px; height:100%; max-height:40px; margin:auto; "
           
          />
    
      </v-list-item>
    </v-list>

    <v-divider class="mb-2" />

    <v-list
      expand
      nav
    >
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

      <template v-for="(item, i) in computedItems">
        <base-item-group
          v-if="item.children"
          :key="`group-${i}`"
          :item="item"
        >
          <!--  -->
        </base-item-group>

        <base-item
          v-else
          :key="`item-${i}`"
          :item="item"
        />
      </template>

      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
    </v-list>

  
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import {
    mapState,
  } from 'vuex'

  export default {
    name: 'DashboardCoreDrawer',

    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      imageUrlLogo: "https://firebasestorage.googleapis.com/v0/b/hebelsolar.appspot.com/o/hebel%2FlogoWhite.png?alt=media&token=ee04c64c-4ab6-454d-8152-970016298a6a",
    user:{},
      itemsAdmin:[
        {
          icon: 'mdi-account-group',
          title: 'Usuários',
          to: '/users',
        },
                 
        {
          icon: 'mdi-domain',
          title: 'Empresas',
          to: '/enterprises',
        }, 
       
      ],
      items2: []
    }),
    created(){
         this.user = this.$session.get("user");
    },

    mounted(){  

      //Color definition
      var primary =  this.$session.get("primary");
      var secondary =  this.$session.get("secondary");
      var images = this.$session.get("images");

   

      //alert(JSON.stringify(Vue.prototype.$vuetify))
      if((primary) &&( this.$vuetify))
        this.$vuetify.theme.themes.light.primary = primary
      if((secondary)&&( this.$vuetify))
        this.$vuetify.theme.themes.light.secondary = secondary;
      
      this.$forceUpdate();
      //this.images = images;
    },

    computed: {
      ...mapState(['barColor', 'barImage']),
      drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.$store.commit('SET_DRAWER', val)
        },
      },
      images:function(){
          var images = this.$session.get("images");
          if(images)
            return images;
          else
            return {
                logo:"https://firebasestorage.googleapis.com/v0/b/hebelsolar.appspot.com/o/hebel%2FlogoWhite.png?alt=media&token=ee04c64c-4ab6-454d-8152-970016298a6a",
                logoWhite :"https://firebasestorage.googleapis.com/v0/b/hebelsolar.appspot.com/o/hebel%2FlogoWhite.png?alt=media&token=ee04c64c-4ab6-454d-8152-970016298a6a"
              };
      },
      items:function(){
        var items = [];
        items.push(
            {
              icon: 'mdi-account',
              title: 'Meus dados',
              to: '/user',
          }
        );
        


       // alert( JSON.stringify(this.user.profile))
       if(this.user.profile){
          if(this.user.profile.id =='admin'){
              items.push(
                  {
                    icon: 'mdi-account-group ',
                    title: 'Usuários',
                    to: '/myusers',
                }
              );

          }
        
          if(this.user.profile.access.enterprise) 
            items.push(  {
              icon: 'mdi-home',
              title: 'Minha empresa',
              to: '/enterprise',
            }); 
         if(this.user.profile.access.products) 
            items.push(  {
              icon: 'mdi-sitemap',
              title: 'Produtos',
              to: '/devices',
            }); 

          if(this.user.profile.access.fields) 
            items.push(  {
                icon: 'mdi-format-list-bulleted-square ',
                title: 'Campos',
                to: '/fields',
            }); 


       }
        items.push(
            {
                icon: 'mdi-card-account-phone-outline ',
                title: 'Contatos',
                to: '/contacts',
          }
        );

        items.push(
            {
              icon: 'mdi-pencil-ruler',
                title:window.style? window.style.deals.label.plural:'Negócios',
                to: '/deals',
          }
        );

        return items;

      //   return [
      //   //       {
      //   //   icon: 'mdi-account',
      //   //   title: 'Meus dados',
      //   //   to: '/user',
      //   // },
      // {
      //         icon: 'mdi-home',
      //         title: 'Minha empresa',
      //         to: '/enterprise',
      //       },
      //   // {
      //   //   icon: 'mdi-sitemap',
      //   //   title: 'Produtos',
      //   //   to: '/devices',
      //   // },
      //      {
      //     icon: 'mdi-card-account-phone-outline ',
      //     title: 'Contatos',
      //     to: '/contacts',
      //   },
      //         {
      //     icon: 'mdi-format-list-bulleted-square ',
      //     title: 'Campos',
      //     to: '/fields',
      //   },
      //   //  {
      //   //   icon: 'mdi-pencil-ruler',
      //   //   title: 'Projetos',
      //   //   to: '/projects',
      //   // },
      //        {
      //     icon: 'mdi-pencil-ruler',
      //     title:window.style? window.style.deals.label.plural:'Negócios',
      //     to: '/deals',
      //   }
    
      // ];
      },

      computedItems () {
        var items;
        if(window.eid =="EFZwxQvKjmt6Bn4ZlzCg")
          items = this.itemsAdmin.concat(this.items);
        else  
          items = this.items;
        return items.map(this.mapItem)
      },
      profile () {
        return {
          avatar: true,
          title: this.$t('avatar'),
        }
      },
    },

    methods: {
      mapItem (item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: this.$t(item.title),
        }
      },
    },
  }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
